$(function () {

    // Variables
    var project_main = $('.project-team__main');
    var project_sidebar = $('.project-team__sidebar');
    var team_description = $('.project-team__text');
    var team_name = $('.project-team__name');
    var team_title = $('.project-team__job');
    var team_img = $('.project-team__img');
    var team_icon = $('.project-team__icon');
    var team_iconB = $('.icon-bigger');
    

    $('.project-team__icon').click(function () {
         // variables
        var team_name_text = $(this).data('team-name');
        var team_title_text = $(this).data('team-title');
        var team_description_text = $(this).data('team-description');
        var team_img_src = $(this).data('team-img');
        var team_icon_src = $(this).data('team-icon');

        // Slide in team content
        project_main.removeClass('project-team__main--active');

        if ($(this).hasClass('project-team__icon--active')) {
            // remove border from sidebar
            project_sidebar.removeClass('project-team__sidebar--active');
        } else { 
            open_team();
            // Remove active class from icons
            $('.project-team__icon').removeClass('project-team__icon--active');
        }

        // Add active class to icon
        $(this).toggleClass('project-team__icon--active');


        function open_team() {
            // Clear data
            team_description.html("");
            team_img.attr('src', '');
            team_name.html("");
            team_title.html("");
            team_iconB.attr('src', "");

            project_main.toggleClass('project-team__main--active');
            team_description.html(team_description_text);
            team_name.html("<strong>" + team_name_text + "</strong>");
            team_title.html(team_title_text);
            team_img.attr('src', team_img_src);
            team_iconB.attr('src', team_icon_src);

            // Add border to sidebar
            project_sidebar.addClass('project-team__sidebar--active');
        }
    });

    // hide sidebar on scroll
    $(window).on('scroll', function() {
        project_main.removeClass('project-team__main--active');
        project_sidebar.removeClass('project-team__sidebar--active');
        team_icon.removeClass('project-team__icon--active');
    });
});

